import { useEffect, useState } from "react";
import { FileText, ImageIcon } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useApp } from "@/context/AppContext";

const IMG = ["image/jpeg", "image/png", "image/webp"];

const useBlob = (api, url, on) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!on) return undefined;
    let u = null;
    api.get(url, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setSrc(u); }).catch(() => setSrc(""));
    return () => u && URL.revokeObjectURL(u);
  }, [api, url, on]);
  return src;
};

export const ReceiptThumb = ({ d }) => {
  const { api, download, t } = useApp();
  const [open, setOpen] = useState(false);
  const isImg = IMG.includes(d.attachment_type);
  const thumb = useBlob(api, `/receipts/${d.id}/image`, isImg);
  const full = useBlob(api, `/receipts/${d.id}/image?size=full`, isImg && open);
  const box = "flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-lg border bg-slate-50";
  if (!d.attachment_file_id) return <div className={box} />;
  if (!isImg || thumb === "") {
    const Icon = d.attachment_type === "application/pdf" ? FileText : ImageIcon;
    return <button type="button" className={`${box} text-slate-500 hover:text-[#B8000F]`} onClick={() => download(`/files/${d.attachment_file_id}`, d.attachment_name)} title={d.attachment_name} data-testid={`receipt-thumb-file-${d.id}`}><Icon className="h-6 w-6" /></button>;
  }
  return (
    <>
      <button type="button" className={`${box} hover:ring-2 hover:ring-[#B8000F]/40`} onClick={() => setOpen(true)} data-testid={`receipt-thumb-${d.id}`}>
        {thumb ? <img src={thumb} alt={d.attachment_name || "reçu"} className="h-full w-full object-cover" /> : <ImageIcon className="h-5 w-5 animate-pulse text-slate-300" />}
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[95vh] max-w-[95vw] overflow-auto bg-black/95 p-2 pt-10 sm:max-w-3xl [&>button]:text-white [&>button]:opacity-90" data-testid={`receipt-viewer-${d.id}`}>
          <DialogTitle className="sr-only">{t("receipt_scan")}</DialogTitle>
          {full ? <img src={full} alt={d.attachment_name || "reçu"} className="mx-auto max-h-[90vh] w-auto" data-testid="receipt-viewer-img" /> : <img src={thumb} alt="" className="mx-auto max-h-[90vh] w-auto opacity-60 blur-[1px]" />}
        </DialogContent>
      </Dialog>
    </>
  );
};
